var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v15H0V0Z",
    fill: "#F93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 15h60v15H0V15Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 30h60v15H0V30Z",
    fill: "#128807"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 28.5a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 27.75a5.25 5.25 0 1 0 0-10.5 5.25 5.25 0 0 0 0 10.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 23.55a1.05 1.05 0 1 0 0-2.1 1.05 1.05 0 0 0 0 2.1ZM35.17 23.455a.27.27 0 1 0 .07-.535.27.27 0 0 0-.07.535Z",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 27.75.18-3.15-.18-1.5-.18 1.5.18 3.15Z",
    fill: "#008"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v45H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndFlag);
export default __webpack_public_path__ + "static/media/ind-flag.ba91d8d8646650576d0bc683914b986b.svg";
export { ForwardRef as ReactComponent };